import { render, staticRenderFns } from "./DetailIllegal.vue?vue&type=template&id=2e2deaf3&scoped=true&"
import script from "./DetailIllegal.vue?vue&type=script&lang=ts&"
export * from "./DetailIllegal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2deaf3",
  null
  
)

export default component.exports